export default "__VITE_ASSET__DXAf5YhR__"